<!-- <script context="module">
    export function load({ error, status }) {
        return {
            props: {
                seo: {
                    title: "HDUK | Error",
                    description: `Error hit!`,
                }
            }
        };
    }
</script> -->

<script>
        // export let title;
        import { onMount } from 'svelte';
        import { seo } from '$stores/seo';
        import posthog from 'posthog-js';
        import { browser } from '$app/environment';
        import { auth } from '$lib/auth';
        import { page } from '$app/stores';
        const logo = 'https://www.hotdraw.co.uk/hd-full-trans.png';
        console.log($page);

	$: error = $page.error;

	onMount(() => {
		if (!browser) return;

		$seo = {
			title: 'HDUK | Error',
			description: `Error hit!`,
			keywords: ''
		};

		const deviceInfo = {
			language: navigator.language,
			userAgent: navigator.userAgent
		};

		posthog.capture('error_page', {
			'Error Type': 'Error Page',
			'Error Message': 'User hit an error page',
			'User ID': $auth?.user?.uid ?? 'Anonymous User',
			'Page URL': window.location.href,
			'Browser Info': navigator.userAgent,
			'Device Info': JSON.stringify(deviceInfo),
			// 'Navigation Path': 'Navigation Path Here',
			Referrer: document.referrer
		});
	});
</script>

<div class="content">
	<h1>It seems we have hit an error!</h1>
	<div class="flex flex-col gap-3">
		{#if $page.error?.message}
			<p>Error message: {$page.error.message}</p>
		{/if}

		{#if $page.error?.errorId}
			<p>Error ID: {$page.error.errorId}</p>
		{/if}
	</div>

	<a href="/">Head back home</a>

        <img src={logo} alt="HotDraw logo" />
</div>

<style lang="scss">
	.content {
		padding: 10rem 2.5%;
	}
</style>
